import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

function useBusinessWebRedesign() {
  const { user } = useUser<LoadedUser>();

  const eligible = !!user?.business?.businessWebRedesignEligible;
  const enabled = !!user?.business?.businessWebRedesignEnabled;
  const locked = !!user?.business?.businessWebRedesignLocked;
  const active = eligible && enabled;

  return {
    eligible,
    enabled,
    locked,
    active,
  };
}

export default useBusinessWebRedesign;
